export class DomainStore {

}